import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useKanban } from '../../contexts/KanbanContext';
import { useSidebar } from '../../contexts/SidebarContext';
import { useTheme } from '../../contexts/ThemeContext';
// Tutorial removido
import AtividadeNotificacao from '../atividades/AtividadeNotificacao';
import AvisoNotificacao from '../avisos/AvisoNotificacao';
// Tutorial removido

const Header: React.FC = () => {
  const { usuario, logout } = useAuth();
  const { atualizacoesTempoReal, toggleAtualizacoesTempoReal } = useKanban();
  const { toggleMenu } = useSidebar();
  const { tema, alternarTema } = useTheme();
  // Tutorial removido
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <header className="h-[72px] bg-bravo-light dark:bg-gray-800 shadow-md px-6 flex items-center justify-between border-b border-gray-200 dark:border-gray-700">
      <div className="flex items-center">
        <div className="block md:hidden mr-4">
          <button
            onClick={toggleMenu}
            className="text-bravo-secondary hover:text-bravo-primary dark:text-gray-300"
            aria-label="Abrir menu lateral"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
        <h1 className="text-xl font-bold text-bravo-dark dark:text-white">
          <span className="text-bravo-primary">Bravo</span>Hub
        </h1>
      </div>

      <div className="flex items-center space-x-6">
        {/* Tutorial removido */}
        <button
          onClick={alternarTema}
          className="flex items-center justify-center h-9 w-9 rounded-md text-bravo-secondary dark:text-gray-300 hover:bg-bravo-tertiary dark:hover:bg-gray-700 transition-colors"
          title={tema === 'escuro' ? 'Ativar modo claro' : 'Ativar modo escuro'}
          aria-label={tema === 'escuro' ? 'Ativar modo claro' : 'Ativar modo escuro'}
        >
          {tema === 'escuro' ? (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
            </svg>
          )}
        </button>
        <button
          onClick={toggleAtualizacoesTempoReal}
          className={`flex items-center px-3 py-1.5 rounded-md ${atualizacoesTempoReal ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500'} hover:bg-opacity-80 transition-colors`}
          title={atualizacoesTempoReal ? 'Desativar atualizações em tempo real' : 'Ativar atualizações em tempo real'}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 mr-1.5 ${atualizacoesTempoReal ? 'text-green-600' : 'text-gray-400'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
          <span className="text-sm font-medium hidden sm:inline">
            {atualizacoesTempoReal ? 'Tempo real ativo' : 'Tempo real inativo'}
          </span>
        </button>
        <AtividadeNotificacao />
        {/* Avisos visíveis apenas para usuários NÃO Expert */}
        {usuario?.tipo !== 'expert' && <AvisoNotificacao />}
        
        <div className="relative">
          <button 
            onClick={toggleDropdown}
            className="flex items-center space-x-2 focus:outline-none"
          >
            <img
              src={usuario?.avatar || '/profilepicture.png'}
              alt="Avatar"
              className="w-9 h-9 rounded-full border-2 border-bravo-primary object-cover"
              onError={(e) => { (e.target as HTMLImageElement).src = '/profilepicture.png'; }}
            />
            <span className="hidden md:block text-sm font-medium text-bravo-secondary dark:text-gray-300">{usuario?.nome.split(' ')[0]}</span>
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-bravo-secondary dark:text-gray-300" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </button>

          {dropdownOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-md shadow-lg py-1 z-10 border border-gray-200 dark:border-gray-700">
              <Link
                to="/perfil"
                className="block px-4 py-2 text-sm text-bravo-secondary dark:text-gray-300 hover:bg-bravo-tertiary dark:hover:bg-gray-700 hover:text-bravo-primary"
                onClick={() => setDropdownOpen(false)}
              >
                <div className="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                  Perfil
                </div>
              </Link>
              <Link
                to="/configuracoes"
                className="block px-4 py-2 text-sm text-bravo-secondary dark:text-gray-300 hover:bg-bravo-tertiary dark:hover:bg-gray-700 hover:text-bravo-primary"
                onClick={() => setDropdownOpen(false)}
              >
                <div className="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  Configurações
                </div>
              </Link>
              <hr className="my-1 border-gray-200 dark:border-gray-700" />
              {/* Tutorial removido */}
              <hr className="my-1 border-gray-200 dark:border-gray-700" />
              <button 
                onClick={() => {
                  logout();
                  setDropdownOpen(false);
                }}
                className="block w-full text-left px-4 py-2 text-sm text-bravo-secondary dark:text-gray-300 hover:bg-bravo-tertiary dark:hover:bg-gray-700 hover:text-bravo-primary"
              >
                <div className="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                  </svg>
                  Sair
                </div>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
